import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { mokiApi } from "../../services/loginApi";
import { totalThunks } from "../../store/salesApiSlice";
import axios from "axios";
import { formatDate } from "../../functions/DateConverter";
import ToastMessage from "../../component/common/Toast";
import { BASE_URL } from "../../component/Url";
import NavigateButton from "../../component/common/NavigateButton";

function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [inputValue, setInputValue] = useState({ id: "", pswd: "" });
  const [toast, setToast] = useState(false);
  const [autoLogin, setAutoLogin] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputValue((prev) => ({ ...prev, [name]: value }));
  };

  const fetchData = () => {
    dispatch(totalThunks(formatDate(new Date())));
  };

  const handleLoginSuccess = () => {
    fetchData();
    navigate("../daily");
  };

  const handleLogin = async (e) => {
    delete axios.defaults.headers.common["Authorization"];
    try {
      const { data, status } = await mokiApi.post("/api/auth/login", {
        id: inputValue.id,
        password: inputValue.pswd,
        remember_me: autoLogin,
      });
      sessionStorage.setItem("accessToken", data.token);
      sessionStorage.setItem("name", data.name);
      mokiApi.defaults.headers.common["Authorization"] = `Bearer ${data.token}`;
      if (status === 200) handleLoginSuccess();
    } catch {
      setToast(true);
    }
  };

  useEffect(() => {
    const refreshToken = async () => {
      try {
        const res = await axios.post(
          `${BASE_URL}api/auth/refresh`,
          {},
          { withCredentials: true }
        );
        if (res.status === 200) {
          const { token, name } = res.data;
          sessionStorage.setItem("accessToken", token);
          sessionStorage.setItem("name", name);
          mokiApi.defaults.headers.common["Authorization"] = `Bearer ${token}`;
          handleLoginSuccess();
        }
      } catch {
        // ignore
      }
    };
    refreshToken();
  }, []);

  return (
    <div className="flex flex-col w-full max-w-[80vw] h-screen items-center mx-auto">
      <div className="flex items-center mt-[20vh] mb-[3vh]">
        <img
          src="/assets/moki_logo(2024).png"
          alt="Moki Logo"
          className="w-[13vw]"
        />
        <h2 className="text-[6vw] m-[2vh]">실시간 매출 분석 데이터</h2>
      </div>

      <div className="w-[90%]">
        <label
          htmlFor="id"
          className="block mt-[5vw] text-[3.3vw] font-medium text-gray-700"
        >
          아이디(사업자번호)
        </label>
        <input
          id="id"
          name="id"
          value={inputValue.id}
          onChange={handleInputChange}
          className="w-full h-[35px] text-lg border-b-2 border-gray-300 focus:outline-none"
        />

        <label
          htmlFor="pswd"
          className="block mt-[5vw] text-[3.3vw] font-medium text-gray-700"
        >
          비밀번호
        </label>
        <input
          id="pswd"
          name="pswd"
          type="password"
          value={inputValue.pswd}
          onChange={handleInputChange}
          className="w-full h-[35px] text-lg border-b-2 border-gray-300 focus:outline-none mt-[1vw]"
        />
      </div>

      <div className="flex items-center mt-[4vw]">
        <input
          id="autoLogin"
          type="checkbox"
          checked={autoLogin}
          onChange={(e) => setAutoLogin(e.target.checked)}
          className="w-[3.5vw] h-[3.5vw] text-blue-600 focus:ring-0"
        />
        <label htmlFor="autoLogin" className="ml-2 text-[3.5vw] text-gray-800">
          자동 로그인
        </label>
      </div>

      <div className="w-[90%] mt-[5vw]">
        <button
          onClick={handleLogin}
          disabled={!(inputValue.id.trim() && inputValue.pswd.trim())}
          className={`w-full h-[10vw] text-[4vw] rounded-md transition-colors
            ${
              inputValue.id.trim() && inputValue.pswd.trim()
                ? "bg-blue-500 text-white hover:bg-blue-600"
                : "bg-gray-300 text-gray-500 cursor-not-allowed"
            }`}
        >
          로그인
        </button>
      </div>

      <NavigateButton text="메인화면으로 돌아가기" margin="5vh" />

      {toast && (
        <ToastMessage
          setToast={setToast}
          text="아이디 또는 비밀번호가 일치하지 않습니다."
        />
      )}
    </div>
  );
}

export default Login;
